import { __decorate, __metadata } from "tslib";
import { SensorValue } from './SensorValue';
import { SerializableObject } from '../decorators';
import { PressureUnit } from '../../utils/unit';
let Pressure = class Pressure extends SensorValue {
  constructor(value = 0, unit = PressureUnit.PASCAL) {
    super(value, undefined, undefined, unit, PressureUnit.PASCAL);
  }
  get value() {
    return this.x;
  }
  set value(x) {
    this.x = x;
  }
};
Pressure = __decorate([SerializableObject(), __metadata("design:paramtypes", [Object, Object])], Pressure);
export { Pressure };